// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d460f618","488":"565a551e"}[chunkId] + ".chunk.js";
};